import { stepConnectorClasses } from "@mui/material";
import { StepConnector } from "@mui/material";
import { styled } from "@mui/material/styles";

import { palette } from "theme/palette";

export const StepperConnector = styled(StepConnector)(() => {
  return {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 10,
      left: "calc(-50% + 16px)",
      right: "calc(50% + 16px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: palette.accent,
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        borderColor: palette.accent,
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderRadius: 1,
      borderTopWidth: 1,
      borderColor: palette.grey,
    },
  };
});
